import * as History from 'history'
import React from 'react'
import { Link } from 'react-router-dom'

import theme from 'theme'

const LowerLink: React.FC<{
  to: History.LocationDescriptor
}> = ({ to, children, ...rest }) => {
  return (
    <section
      css={{
        fontSize: theme.fontSizes[2],
        textAlign: 'center',
        marginTop: theme.space[3]
      }}
    >
      <Link css={{ color: theme.colors.steel[1] }} to={to} {...rest}>
        {children}
      </Link>
    </section>
  )
}

export default LowerLink
